export class PersonDocumentType {
  public static readonly POWER_VALIDITY = 1;
  public static readonly RUC_FILE = 2;
}
